import { all } from 'redux-saga/effects';
import payrollStatusPdfWatcher from './download-pdf-saga';

export default function* rootSaga(action) {
	yield all([payrollStatusPdfWatcher(action)]);
}
